import { getSettingHotjarRecordingEnabled } from "@faire/web/common/settings/getSettingHotjarRecordingEnabled";
import { getSettingPosthogApiKey } from "@faire/web/common/settings/getSettingPosthogApiKey";

/**
 * Prefer PostHog over Hotjar when both are enabled.
 * We consider PostHog enabled when an API key exists and the recording flag is true.
 */
export const isPosthogEnabled = (): boolean => {
  const hotjarOrRecordingEnabled = getSettingHotjarRecordingEnabled();
  const posthogApiKey = getSettingPosthogApiKey();

  return Boolean(hotjarOrRecordingEnabled && posthogApiKey);
};

export const getPosthogApiKey = (): string | undefined =>
  getSettingPosthogApiKey();
